// 链 ID 常量定义

// ETH 相关链 ID - 这些链不需要显示 receiverAddress 输入框
export const ETH_CHAIN_IDS = {
  MAINNET: 1, // ETH 主网
  SEPOLIA: 11155111, // Sepolia 测试网
} as const

// ETH 链 ID 数组，用于判断
export const ETH_CHAIN_ID_LIST = Object.values(ETH_CHAIN_IDS)

// 判断是否为 ETH 相关链
export const isEthChain = (chainId: number | string): boolean => {
  const numericChainId =
    typeof chainId === 'string' ? parseInt(chainId, 10) : chainId
  return ETH_CHAIN_ID_LIST.includes(
    numericChainId as (typeof ETH_CHAIN_ID_LIST)[number]
  )
}

// 不受充值金额限制的链 ID - 包括 ETH 和 Arbitrum（主网和测试网）
export const UNLIMITED_DEPOSIT_CHAIN_IDS = {
  MAINNET: 1, // ETH 主网
  SEPOLIA: 11155111, // Sepolia 测试网
  ARBITRUM: 42161, // Arbitrum One 主网
  ARBITRUM_SEPOLIA: 421614, // Arbitrum Sepolia 测试网
} as const

// 不受充值金额限制的链 ID 数组
export const UNLIMITED_DEPOSIT_CHAIN_ID_LIST = Object.values(
  UNLIMITED_DEPOSIT_CHAIN_IDS
)

// 判断是否为不受充值金额限制的链（ETH + Arbitrum）
export const isUnlimitedDepositChain = (chainId: number | string): boolean => {
  const numericChainId =
    typeof chainId === 'string' ? parseInt(chainId, 10) : chainId
  return UNLIMITED_DEPOSIT_CHAIN_ID_LIST.includes(
    numericChainId as (typeof UNLIMITED_DEPOSIT_CHAIN_ID_LIST)[number]
  )
}

// Arbitrum 链上不受限制的代币符号（只有 USDT）
export const ARBITRUM_UNLIMITED_TOKENS = {
  USDT: true,
  // 如果需要添加其他代币，在这里添加
  // USDC: true,
} as const

// 判断特定链和代币组合是否需要显示大额充值限制
export const shouldShowDepositLimit = (
  chainId: number | string,
  tokenSymbol?: string
): boolean => {
  const numericChainId =
    typeof chainId === 'string' ? parseInt(chainId, 10) : chainId

  // ETH 主网和 Sepolia 测试网：所有代币都不受限制
  if (numericChainId === 1 || numericChainId === 11155111) {
    return false
  }

  // Arbitrum 链：只有 USDT 不受限制，其他代币仍受限制
  if (numericChainId === 42161 || numericChainId === 421614) {
    if (!tokenSymbol) return true // 如果没有代币符号，默认显示限制

    // 基础代币（ETH）不受限制
    if (tokenSymbol.toUpperCase() === 'ETH') {
      return false
    }

    // 检查是否为 USDT
    return !ARBITRUM_UNLIMITED_TOKENS[
      tokenSymbol.toUpperCase() as keyof typeof ARBITRUM_UNLIMITED_TOKENS
    ]
  }

  // 其他链：都显示限制
  return true
}

// 其他常用链 ID（可选，用于参考）
export const OTHER_CHAIN_IDS = {
  BNB_CHAIN: 56, // BNB Chain
  POLYGON: 137, // Polygon
  OPTIMISM: 10, // Optimism
} as const
